import {
  Alert,
  AlertIcon,
  Flex,
  HStack,
  AlertTitle,
  AlertDescription,
  Button,
  IconButton,
  CloseIcon,
  type ButtonProps,
  SlideFade,
  VStack,
  type AlertStatus,
} from '@frontend/legacy-components';

export interface ListContentAlertProps {
  isVisible: boolean;
  title: string;
  description?: string;
  status: AlertStatus;
  onClickCTA?: () => void;
  ctaText?: string;
  onDismissAlert?: () => void;
  ctaButtonProps?: ButtonProps;
}

export const ListContentAlert = ({
  isVisible,
  onClickCTA,
  ctaText = 'Clear',
  onDismissAlert,
  title,
  description,
  status,
  ctaButtonProps,
}: ListContentAlertProps) => (
  <SlideFade in={isVisible} unmountOnExit offsetY="0.5rem">
    <Flex>
      <Alert
        as={Flex}
        status={status}
        borderRadius="lg"
        boxShadow="page"
        alignItems="center"
        px={1.5}
        py={1}
        size="sm"
      >
        <AlertIcon />
        <Flex justify="space-between" align="stretch" flex={1}>
          <VStack spacing={-2} align="start" justifyContent="center">
            <AlertTitle>{title}</AlertTitle>
            {description && <AlertDescription>{description}</AlertDescription>}
          </VStack>
          <HStack gap={1} align="center" marginLeft="auto">
            <Button
              size="md"
              variant="primary"
              onClick={onClickCTA ?? onDismissAlert}
              {...ctaButtonProps}
            >
              {ctaText}
            </Button>
            {onDismissAlert && (
              <IconButton
                size="sm"
                aria-label="Dismiss alert"
                onClick={onDismissAlert}
              >
                <CloseIcon />
              </IconButton>
            )}
          </HStack>
        </Flex>
      </Alert>
    </Flex>
  </SlideFade>
);
